module.exports = __webpack_public_path__ + "media/images/svg/graph-05a30a9dd5e565e47bfabf8b4f5f4474.svg";